<template>
  <div id="material-kit">
    <div
      class=""
      :class="{
        'nav-open': NavbarStore.showNavbar,
        'muli-font': getToken().bank_id == SOURCE_BANK.BIDV,
        'sp-font': getToken().bank_id != SOURCE_BANK.BIDV
      }"
    >
      <login-dialog />
      <div v-if="$store.getters.isShowOtp">
        <otp-dialog />
      </div>
      <div>
        <Profile :key="$store.getters.isReRenderComponent + 2" />
        <DialogWallet :key="$store.getters.isReRenderComponent" />
        <DialogMenuApp :key="$store.getters.isReRenderComponent + 1" />
        <DialogUpdateInfo />
      </div>
      <router-view name="header" />
      <div>
        <router-view />
      </div>
      <router-view name="footer" />
      <router-view name="mobile-navbar-bottom" />
      <!-- <NavBarMobileBottom /> -->
    </div>
  </div>
</template>

<script>
import { isEmpty } from "./utils/validate";
import { getBackGround, getToken } from "./utils/wapAuth";
import LoginDialog from "./views/components/LoginDialog.vue";
import PointResource from "@/views/api/point";
import OtpDialog from "./views/pages/wapV2/otp/DialogOtp.vue";
import Profile from "./views/pages/wapV2/profile/Index.vue";
import DialogWallet from "./views/pages/wapV2/profile/components/DialogWallet.vue";
import DialogMenuApp from "./views/pages/wapV2/profile/components/DialogMenu.vue";
import DialogUpdateInfo from "./views/pages/wapV2/profile/components/DialogUpdateInfo.vue";
import { SOURCE_BANK } from "./constant/contant";
import NavBarMobileBottom from "./layout/WapV2/NavBarMobileBottom.vue";
export default {
  created() {
    setTimeout(() => {
      this.$store.dispatch("setLoadingPage", false);
    }, 1800);
  },
  mounted() {
    // console.log("render_______________________decodeToken", getToken());
    if (!isEmpty(getToken().vga)) {
      this.onGetPoint();
      this.idInterVal = setInterval(() => {
        this.onGetPoint();
      }, 20 * 1000);
      let retries = 30;

      const checkStringee = setInterval(() => {
        if (
          window.StringeeSoftChat &&
          typeof window.StringeeSoftChat.connectWS === "function"
        ) {
          this.$store.dispatch("connectChat", getToken().vga);
          clearInterval(checkStringee);
        } else {
          console.warn("Đang chờ StringeeSoftChat sẵn sàng...");
        }
        if (retries > 0) {
          console.log("Retrying...", retries);
        } else {
          clearInterval(checkStringee);
        }
        retries--;
      }, 800);
    }
  },
  watch: {
    "$store.getters.isReRenderComponent": function(newValue, oldValue) {
      if (newValue > 1 && !isEmpty(getToken().vga)) {
        clearInterval(this.idInterVal);
        this.onGetPoint();
        this.idInterVal = setInterval(() => {
          this.onGetPoint();
        }, 20 * 1000);
      }
    },
    "$store.getters.isShowProfile": function(newValue, oldValue) {
      if (newValue) {
        this.hideOverflow();
      } else {
        this.showOverflow();
      }
    },
    "$store.getters.isShowMenuApp": function(newValue, oldValue) {
      if (newValue) {
        this.hideOverflow();
      } else {
        this.showOverflow();
      }
    },
    "$store.getters.isShowOtp": function(newValue, oldValue) {
      console.log("newValue)))))))))))))))))", newValue);

      if (newValue) {
        setTimeout(() => {
          this.hideOverflow();
        }, 150);
      } else {
        this.showOverflow();
      }
    }
  },
  components: {
    LoginDialog,
    OtpDialog,
    Profile,
    DialogWallet,
    DialogMenuApp,
    DialogUpdateInfo
    // NavBarMobileBottom
  },
  data() {
    return {
      SOURCE_BANK: SOURCE_BANK,
      idInterVal: null,
      gg: "SF Pro Display, sans-serif",
      bg: getBackGround()
    };
  },
  beforeDestroy() {
    clearInterval(this.idInterVal);
  },
  methods: {
    getToken,
    location() {
      function successCallback(position) {}
      function errorCallback(error) {
        // console.log(error.message);
      }

      navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
      var watchId = navigator.geolocation.watchPosition(successCallback);
      navigator.geolocation.clearWatch(watchId);
    },
    hideOverflow() {
      const dBody = document.body;
      document.documentElement.style.overflow = "hidden";
      dBody.style.position = "fixed";
      dBody.style.height = "100%";
      dBody.style.overflow = "hidden";
      dBody.style.width = "100%";
    },
    showOverflow() {
      const dBody = document.body;
      dBody.style.position = "";
      dBody.style.height = "";
      dBody.style.width = "";
      dBody.style.overflow = "";
      document.documentElement.style.overflow = "";
    },
    onGetPoint() {
      PointResource.getPoint({ uid: getToken().vga }).then(res => {
        const { error_code, data } = res;
        // console.log("res________", res);
        if (!data || error_code != 0) {
          clearInterval(this.idInterVal);
          return;
        }
        if (error_code === 0) {
          const point = data.point || 0;
          this.$store.dispatch("point/setPoint", point);
        }
      });
    }
  }
};
</script>
<style>
body {
  padding-right: 0 !important;
}
.text-uppercase {
  text-transform: uppercase;
}
.text-hover:hover {
  text-decoration: underline;
}
.custom_chat_bk {
  z-index: -1 !important;
}
.muli-font {
  font-family: "Plus Jakarta Sans" !important;
}
.sp-font {
  font-family: "SF Pro Display", sans-serif !important;
}
.bg-main {
  background-color: rgba(23, 71, 158, 1);
}

.c-main {
  color: rgba(23, 71, 158, 1);
}
.c-black {
  color: black;
}
.ma-0 {
  margin: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mr-0 {
  margin-right: 0 !important;
}

.ml-0 {
  margin-left: 0 !important;
}

.pa-0 {
  padding: 0 !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pr-0 {
  padding-right: 0 !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pl-0 {
  padding-left: 0 !important;
}

.ma-1 {
  margin: 1px !important;
}

.ma-2 {
  margin: 2px !important;
}

.ma-3 {
  margin: 3px !important;
}

.ma-4 {
  margin: 4px !important;
}

.ma-5 {
  margin: 5px !important;
}

.ma-6 {
  margin: 6px !important;
}

.ma-7 {
  margin: 7px !important;
}

.ma-8 {
  margin: 8px !important;
}

.ma-9 {
  margin: 9px !important;
}

.ma-10 {
  margin: 10px !important;
}

.ma-11 {
  margin: 11px !important;
}

.ma-12 {
  margin: 12px !important;
}

.ma-13 {
  margin: 13px !important;
}

.ma-14 {
  margin: 14px !important;
}

.ma-15 {
  margin: 15px !important;
}

.ma-16 {
  margin: 16px !important;
}

.pa-1 {
  padding: 1px !important;
}

.pa-2 {
  padding: 2px !important;
}

.pa-3 {
  padding: 3px !important;
}

.pa-4 {
  padding: 4px !important;
}

.pa-5 {
  padding: 5px !important;
}

.pa-6 {
  padding: 6px !important;
}

.pa-7 {
  padding: 7px !important;
}

.pa-8 {
  padding: 8px !important;
}

.pa-9 {
  padding: 9px !important;
}

.pa-10 {
  padding: 10px !important;
}

.pa-11 {
  padding: 11px !important;
}

.pa-12 {
  padding: 12px !important;
}

.pa-13 {
  padding: 13px !important;
}

.pa-14 {
  padding: 14px !important;
}

.pa-15 {
  padding: 15px !important;
}

.pa-16 {
  padding: 16px !important;
}

.mt-1 {
  margin-top: 1px !important;
}

.mt-2 {
  margin-top: 2px !important;
}

.mt-3 {
  margin-top: 3px !important;
}

.mt-4 {
  margin-top: 4px !important;
}

.mt-5 {
  margin-top: 5px !important;
}

.mt-6 {
  margin-top: 6px !important;
}

.mt-7 {
  margin-top: 7px !important;
}

.mt-8 {
  margin-top: 8px !important;
}

.mt-9 {
  margin-top: 9px !important;
}

.mt-10 {
  margin-top: 10px !important;
}

.mt-11 {
  margin-top: 11px !important;
}

.mt-12 {
  margin-top: 12px !important;
}

.mt-13 {
  margin-top: 13px !important;
}

.mt-14 {
  margin-top: 14px !important;
}

.mt-15 {
  margin-top: 15px !important;
}

.mt-16 {
  margin-top: 16px !important;
}

.pt-1 {
  padding-top: 1px !important;
}

.pt-2 {
  padding-top: 2px !important;
}

.pt-3 {
  padding-top: 3px !important;
}

.pt-4 {
  padding-top: 4px !important;
}

.pt-5 {
  padding-top: 5px !important;
}

.pt-6 {
  padding-top: 6px !important;
}

.pt-7 {
  padding-top: 7px !important;
}

.pt-8 {
  padding-top: 8px !important;
}

.pt-9 {
  padding-top: 9px !important;
}

.pt-10 {
  padding-top: 10px !important;
}

.pt-11 {
  padding-top: 11px !important;
}

.pt-12 {
  padding-top: 12px !important;
}

.pt-13 {
  padding-top: 13px !important;
}

.pt-14 {
  padding-top: 14px !important;
}

.pt-15 {
  padding-top: 15px !important;
}

.pt-16 {
  padding-top: 16px !important;
}

.ml-1 {
  margin-left: 1px !important;
}

.ml-2 {
  margin-left: 2px !important;
}

.ml-3 {
  margin-left: 3px !important;
}

.ml-4 {
  margin-left: 4px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.ml-6 {
  margin-left: 6px !important;
}

.ml-7 {
  margin-left: 7px !important;
}

.ml-8 {
  margin-left: 8px !important;
}

.ml-9 {
  margin-left: 9px !important;
}

.ml-10 {
  margin-left: 10px !important;
}

.ml-11 {
  margin-left: 11px !important;
}

.ml-12 {
  margin-left: 12px !important;
}

.ml-13 {
  margin-left: 13px !important;
}

.ml-14 {
  margin-left: 14px !important;
}

.ml-15 {
  margin-left: 15px !important;
}

.ml-16 {
  margin-left: 16px !important;
}

.mb-1 {
  margin-bottom: 1px !important;
}

.mb-2 {
  margin-bottom: 2px !important;
}

.mb-3 {
  margin-bottom: 3px !important;
}

.mb-4 {
  margin-bottom: 4px !important;
}

.mb-5 {
  margin-bottom: 5px !important;
}

.mb-6 {
  margin-bottom: 6px !important;
}

.mb-7 {
  margin-bottom: 7px !important;
}

.mb-8 {
  margin-bottom: 8px !important;
}

.mb-9 {
  margin-bottom: 9px !important;
}

.mb-10 {
  margin-bottom: 10px !important;
}

.mb-11 {
  margin-bottom: 11px !important;
}

.mb-12 {
  margin-bottom: 12px !important;
}

.mb-13 {
  margin-bottom: 13px !important;
}

.mb-14 {
  margin-bottom: 14px !important;
}

.mb-15 {
  margin-bottom: 15px !important;
}

.mb-16 {
  margin-bottom: 16px !important;
}

.mr-1 {
  margin-right: 1px !important;
}

.mr-2 {
  margin-right: 2px !important;
}

.mr-3 {
  margin-right: 3px !important;
}

.mr-4 {
  margin-right: 4px !important;
}

.mr-5 {
  margin-right: 5px !important;
}

.mr-6 {
  margin-right: 6px !important;
}

.mr-7 {
  margin-right: 7px !important;
}

.mr-8 {
  margin-right: 8px !important;
}

.mr-9 {
  margin-right: 9px !important;
}

.mr-10 {
  margin-right: 10px !important;
}

.mr-11 {
  margin-right: 11px !important;
}

.mr-12 {
  margin-right: 12px !important;
}

.mr-13 {
  margin-right: 13px !important;
}

.mr-14 {
  margin-right: 14px !important;
}

.mr-15 {
  margin-right: 15px !important;
}

.mr-16 {
  margin-right: 16px !important;
}

.pr-1 {
  padding-right: 1px !important;
}

.pr-2 {
  padding-right: 2px !important;
}

.pr-3 {
  padding-right: 3px !important;
}

.pr-4 {
  padding-right: 4px !important;
}

.pr-5 {
  padding-right: 5px !important;
}

.pr-6 {
  padding-right: 6px !important;
}

.pr-7 {
  padding-right: 7px !important;
}

.pr-8 {
  padding-right: 8px !important;
}

.pr-9 {
  padding-right: 9px !important;
}

.pr-10 {
  padding-right: 10px !important;
}

.pr-11 {
  padding-right: 11px !important;
}

.pr-12 {
  padding-right: 12px !important;
}

.pr-13 {
  padding-right: 13px !important;
}

.pr-14 {
  padding-right: 14px !important;
}

.pr-15 {
  padding-right: 15px !important;
}

.pr-16 {
  padding-right: 16px !important;
}

.pb-1 {
  padding-bottom: 1px !important;
}

.pb-2 {
  padding-bottom: 2px !important;
}

.pb-3 {
  padding-bottom: 3px !important;
}

.pb-4 {
  padding-bottom: 4px !important;
}

.pb-5 {
  padding-bottom: 5px !important;
}

.pb-6 {
  padding-bottom: 6px !important;
}

.pb-7 {
  padding-bottom: 7px !important;
}

.pb-8 {
  padding-bottom: 8px !important;
}

.pb-9 {
  padding-bottom: 9px !important;
}

.pb-10 {
  padding-bottom: 10px !important;
}

.pb-11 {
  padding-bottom: 11px !important;
}

.pb-12 {
  padding-bottom: 12px !important;
}

.pb-13 {
  padding-bottom: 13px !important;
}

.pb-14 {
  padding-bottom: 14px !important;
}

.pb-15 {
  padding-bottom: 15px !important;
}

.pb-16 {
  padding-bottom: 16px !important;
}

.pl-1 {
  padding-left: 1px !important;
}

.pl-2 {
  padding-left: 2px !important;
}

.pl-3 {
  padding-left: 3px !important;
}

.pl-4 {
  padding-left: 4px !important;
}

.pl-5 {
  padding-left: 5px !important;
}

.pl-6 {
  padding-left: 6px !important;
}

.pl-7 {
  padding-left: 7px !important;
}

.pl-8 {
  padding-left: 8px !important;
}

.pl-9 {
  padding-left: 9px !important;
}

.pl-10 {
  padding-left: 10px !important;
}

.pl-11 {
  padding-left: 11px !important;
}

.pl-12 {
  padding-left: 12px !important;
}

.pl-13 {
  padding-left: 13px !important;
}

.pl-14 {
  padding-left: 14px !important;
}

.pl-15 {
  padding-left: 15px !important;
}
.mt-10 {
  margin-top: 10px;
}
.mr-20 {
  margin-right: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
.mx-10 {
  margin-left: 10px;
  margin-right: 10px;
}
.my-10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

.mb-25 {
  margin-bottom: 25px;
}
.c-white {
  color: white !important;
}
img {
  cursor: pointer;
  -webkit-touch-callout: default !important;
}
.mt-20 {
  margin-top: 20px;
}
.ml-20 {
  margin-left: 20px;
}
.px-15 {
  padding: 0 15px;
}
.width-100 {
  width: 100%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.flex {
  display: flex !important;
}
.flex-wrap {
  flex-wrap: wrap;
}
.colum {
  flex-direction: column !important;
}
.justify-content-center {
  justify-content: center !important;
}
.justify-content-space-between {
  justify-content: space-between !important;
}
.justify-content-around {
  justify-content: space-around;
}
.align-items-center {
  align-items: center;
}
.text-align-center {
  text-align: center;
}
.cursor-pointer {
  cursor: pointer !important;
}
.mx-10 {
  margin: 0 10px;
}
.m-0 {
  margin: 0 !important;
}
.p-0 {
  padding: 0 !important;
}
.c-tiny-max {
  font-size: 10px;
}
.c-tiny {
  font-size: 12px !important;
}
.c-caption {
  font-size: 14px !important;
}
.c-body2 {
  font-size: 16px;
}
.c-body1 {
  font-size: 18px;
}
.c-title2 {
  font-size: 20px;
}
.c-title1 {
  font-size: 24px;
}

.c-h5 {
  font-size: 20px;
}
.c-h4 {
  font-size: 24px;
}
.c-h3 {
  font-size: 30px;
}
.c-h2 {
  font-size: 36px;
}
.c-h1 {
  font-size: 72px;
}
.c-black-text {
  color: black !important;
}
.c-span-text {
  color: #858585 !important;
}

.c-initial-text {
  color: #272626;
}
.c-inherit-text {
  color: v-bind("bg.c_inherit_text") !important;
}
.c-btn-hotline {
  background: v-bind("bg.c_btn_hotline");
}
.c-red-text {
  color: v-bind("bg.c_red_text");
}
.c-white-text {
  color: v-bind("bg.c_white_text") !important;
}
.c-text-main {
  color: v-bind("bg.c_text_main") !important;
}
.c-white-text-important {
  color: v-bind("bg.c_white_text_important") !important;
}
.c-white-text-important:hover {
  color: v-bind("bg.c_white_text_important") !important;
}
.c-white-text-important:focus {
  color: v-bind("bg.c_white_text_important") !important;
}
.c-thin-text {
  font-weight: 300;
}
.c-regular-text {
  font-weight: 400;
}
.c-medium-text {
  font-weight: 500 !important;
}
.c-rather-text {
  font-weight: 600 !important;
}
.c-bold-text {
  font-weight: 700 !important;
}
.fw-cv1 {
  font-weight: v-bind("bg.fw_cv1") !important;
}
.fw-cv2 {
  font-weight: v-bind("bg.fw_cv2") !important;
}
.fw-cv3 {
  font-weight: v-bind("bg.fw_cv3") !important;
}
.fw-cv4 {
  font-weight: v-bind("bg.fw_cv4") !important;
}
.fs-cv1 {
  font-size: v-bind("bg.fs_cv1") !important;
}
.fs-cv2 {
  font-size: v-bind("bg.fs_cv2") !important;
}
.fs-cv3 {
  font-size: v-bind("bg.fs_cv3") !important;
}
.fs-cv4 {
  font-size: v-bind("bg.fs_cv4") !important;
}
.c-cyan-background {
  background-color: v-bind("bg.c_cyan_background");
}
.c-white-background {
  background: v-bind("bg.c_white_background");
}
.c-inherit-background {
  background: v-bind("bg.c_inherit_background");
}
.bg-btn-main {
  background: v-bind("bg.c_button_main") !important;
}
.c-border-main {
  border-color: v-bind("bg.c_border") !important;
}

.c-text-price {
  color: v-bind("bg.c_text_price") !important;
}
.bg-btn-sale {
  background-color: #e31d1d !important;
}
.float-right {
  float: right;
}
.mb-0 {
  margin-bottom: 0;
}
.c-icon {
  color: #c0c4cc;
}
.el-rate__icon {
  margin-right: 5px !important;
}
.c-header {
  background-color: v-bind("bg.c_header");
}
.c-footer {
  background-color: v-bind("bg.c_footer");
}
.c-menu-header {
  color: v-bind("bg.c_menu_header") !important;
}
.c-menu-footer {
  color: v-bind("bg.c_menu_footer") !important;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .el-autocomplete-suggestion {
    width: 300px !important;
    left: 50px !important;
  }
}
.input-search-bar input::placeholder {
  font-weight: 500;
  font-size: 14px;
  color: v-bind("bg.c_placeholder") !important;
}
.input-search-bar input {
  background: transparent;
  width: 100%;
  border: none;
  border-radius: 100px;
  padding-bottom: 2px;
}
</style>
<style lang="scss">
//wapV2
$bg-btn-time: #e31d1d;
$color-999999: #999999;
$color-0091D2: #0091d2;
$btn-color: v-bind("bg.c_button_main");
$tag-color: v-bind("bg.c_text_price");
$bg-select: #d4d4d4;
$text-select: #090710;
$placeholder-select: #666666;
$bg-tab: v-bind("bg.c_text_main");
$bg-tab-active: #d4e2fb;
$white-color: #fff;
$border-color: #c0c0c0;
$text-price-sale: v-bind("bg.c_text_price");
$text-price-init: #929292;
$bg-service-icon: #e5e6eb;
$progress-price-color: #ffa3a3;
$white-color: #fff;
$gray-dark: #333;
$font: v-bind("bg.font");

* {
  font-family: "Plus Jakarta Sans" !important;
}

.color-999999 {
  color: $color-999999 !important;
}
.color-0091D2 {
  color: $color-0091D2 !important;
}
.w-100 {
  width: 100% !important;
}
.fw-450 {
  font-weight: 450 !important;
}
.fw-500 {
  font-weight: 500 !important;
}
.fw-550 {
  font-weight: 550 !important;
}
.fw-600 {
  font-weight: 600 !important;
}
.mr-70 {
  margin-right: 70px !important;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
.d-flex {
  display: flex !important;
}
.flex-1 {
  flex: 1;
}
.flex-row {
  flex-direction: row !important;
}
.flex-column {
  flex-direction: column !important;
}
.justify-content-start {
  justify-content: start !important;
}
.justify-content-center {
  justify-content: center !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-around {
  justify-content: space-around !important;
}
.justify-content-right {
  justify-content: right !important;
}
.align-items-start {
  align-items: start !important;
}
.align-items-center {
  align-items: center !important;
}
.align-items-right {
  align-items: right !important;
}
.lh-12 {
  line-height: 12px !important;
}
.lh-14 {
  line-height: 14px !important;
}
.lh-16 {
  line-height: 16px !important;
}
.lh-18 {
  line-height: 18px !important;
}
.lh-20 {
  line-height: 20px !important;
}
.lh-24 {
  line-height: 24px !important;
}
.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
.position-fixed {
  position: fixed;
}
.text-transform-none {
  text-transform: none !important;
}
.p-12 {
  padding: 12px !important;
}
.pt-20 {
  padding-top: 20px !important;
}
.pt-10 {
  padding-top: 10px !important;
}
.pl-20 {
  padding-left: 20px !important;
}
.pr-20 {
  padding-right: 20px !important;
}
.pb-20 {
  padding-bottom: 20px !important;
}
.pb-10 {
  padding-bottom: 10px !important;
}
.border-radius-8 {
  border-radius: 8px !important;
}

.border-radius-12 {
  border-radius: 12px !important;
}

.border-radius-10 {
  border-radius: 10px !important;
}
.border-top-left-radius-10 {
  border-top-left-radius: 10px !important;
}
.border-top-right-radius-10 {
  border-top-right-radius: 10px !important;
}
.border-bottom-left-radius-10 {
  border-bottom-left-radius: 10px !important;
}
.border-bottom-right-radius-10 {
  border-bottom-right-radius: 10px !important;
}
.cursor-pointer {
  cursor: pointer;
}
.el-date-picker {
  font-family: "SF Pro Display", sans-serif !important;
}
.el-picker-panel__icon-btn {
  font-size: 18px !important;
  padding: 0 5px !important;
  margin-top: 5px !important;
}
.hidden-text {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
//time-countdown
.btn-time {
  background: $bg-btn-time;
  color: $white-color;
}

//crollbar
.list-tee-container,
.dialogFilter {
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
// el-select
.hidden-close-tag {
  .el-tag__close {
    display: none !important;
  }
}
.select-hio {
  .el-select {
    .el-select__tags {
      max-width: none !important;
      .el-tag {
        background-color: #d4d4d4 !important;
        border: none !important;
        .el-select__tags-text {
          color: $gray-dark !important;
          font-weight: 600 !important;
        }
        i {
          // display: none !important;
        }
        .el-tag__close {
          background: inherit;
          color: $gray-dark;
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    .el-input {
      // height: 47px;
      max-height: 80px;
      // width: 100% !important;
      input {
        background: transparent;
        // padding: 12px 5px 12px 15px;
        // height: 47px;
      }
      .el-input__inner {
        font-size: 12px !important;
        padding: 0 10px !important;
        background-color: #ebebeb !important;
        // background-color: red !important;
        color: $text-select !important;
        font-weight: 600;
        &::placeholder {
          font-weight: 500;
          color: $placeholder-select;
        }
      }
      .el-input__suffix > .el-input__suffix-inner > i {
        color: $gray-dark !important;
      }
    }
  }
}

//tab list tee
.tab-card {
  .v-toolbar {
    box-shadow: none !important;
  }
  .v-tab {
    padding-bottom: 15px !important;
    padding-top: 15px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    color: $bg-tab !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    max-width: 50px !important;
    &:active {
      background-color: $bg-tab-active;
    }
  }
  .v-slide-group__prev,
  .v-slide-group__prev--disabled {
    display: none !important;
  }
  .v-slide-group__wrapper {
    width: 100%;
    border-bottom: 0.2px solid $border-color !important;
    border-top: 0.2px solid $border-color !important;
  }
  .v-slide-group__wrapper {
    width: 100%;
  }
  .v-tab--active {
    background-color: $bg-tab-active;
    text-decoration: none !important;
  }

  .v-tab--active .v-tab__content {
    border-bottom: none;
  }
}

// time countdown
.golf-good-price {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time-good-price-container {
  margin: 0 !important;
  align-items: center;
  display: flex;
}
.text-time {
  margin: 0;
  font-size: 12px;
  color: $gray-dark;
  font-weight: 500;
}
.time-container {
  display: flex;
  align-items: center;
  margin: 0 0 0 10px;
  border: none !important;
}
.btn-time {
  padding: 0;
  width: 35px;
  height: 35px;
  border-radius: 4px;
  margin: 0 2px !important;
  font-weight: 500 !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .btn-time {
    width: 25px !important;
    height: 25px !important;
  }
}

//card tee ....................................

.body-card {
  border-radius: 5px;
  position: relative;
  .body-card-icon_heart {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.image {
  width: 100% !important;
  height: 140px !important;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  object-fit: cover;
  object-position: top;
}
.price-container {
  align-items: center;
  display: flex;
  margin-top: 2px;
}
.price-text {
  margin: 0;
  font-size: 10px;
  line-height: 12px;
  font-weight: 450;
}
.price-sale {
  margin: 0 10px 2px 10px;
  color: $text-price-sale;
  font-weight: 700;
  font-size: 14px;
  margin: 0;
}
.price-initial {
  font-weight: 500;
  font-size: 10px;
  color: $text-price-init;
}

.progress-container {
  position: relative;
}

.text-price-hot {
  position: absolute;
  top: -3px;
  color: $white-color;
  text-transform: uppercase;
  left: 25px;
  font-size: 10px;
}
.btn-submit-active {
  border-radius: 6px !important;
  background: $btn-color !important;
  width: 100%;
  border: none !important;
}
.info-service-text {
  font-size: 9px;
  font-weight: 400;
}
.info-service-arrow-icon {
  height: 5px;
  margin-left: 2px;
}
.info-service-icon-box {
  display: flex;
  .info-service-icon {
    height: 22px;
    width: 22px;
    background-color: $bg-service-icon;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
  }
}
.mt-negative-4 {
  margin-top: -4px;
}
.hot-deal-title {
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.mt-6 {
  margin-top: 6px;
}

.deal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.progress-price .el-progress-bar .el-progress-bar__outer {
  background: $progress-price-color !important;
}
.theme-xanh .vdatetime-popup__header,
.theme-xanh .vdatetime-calendar__month__day--selected > span > span,
.theme-xanh .vdatetime-calendar__month__day--selected:hover > span > span {
  background: v-bind("bg.colorMain") !important;
}
.vdatetime-popup {
  font-family: v-bind("bg.font") !important;
}
.theme-xanh .vdatetime-year-picker__item--selected,
.theme-xanh .vdatetime-time-picker__item--selected,
.theme-xanh .vdatetime-popup__actions__button {
  color: v-bind("bg.colorMain") !important;
}
.theme-xanh input {
  width: 100% !important;
  font-size: 16px !important;
}
.theme-xanh input::placeholder {
  color: #c0c4cc !important;
  font-size: 16px !important;
}
</style>
